// extracted by mini-css-extract-plugin
export default {"wrapper":"Invoice_wrapper__JHSSP","title":"Invoice_title__nV0Yd","row":"Invoice_row__TUJu+","productImage":"Invoice_productImage__isdpa","btnContainer":"Invoice_btnContainer__GBv0j"};